import useSWR from "swr";

import { keys } from "@/src/shared/api/keys";

import { detectCountry } from "./api";

export const useDetectCountry = () => {
  return useSWR(
    keys.country.detect,
    detectCountry
  );
};